
<app-goal-tabs></app-goal-tabs>
<div id="container">
    <app-goals-item-container></app-goals-item-container>
</div>

